import {OccPlaceholderAssets} from '@vista/omnichannel-components-ui'
import { defaultOccPlaceholderAssets } from "@vista/omnichannel-components-ui/lib/src/lib/context/occ/types/placeholder-assets";

export function getPlaceholderAssetsData():OccPlaceholderAssets {
    return {
        ...defaultOccPlaceholderAssets
    }
}